module.exports = __webpack_public_path__ + "static/media/icon_cloud_upload.6de9b667.svg";